/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { HubbleCompaniesServiceUpdateUserData } from "./HubbleCompaniesServiceUpdateUserData";
import {
  HubbleCompaniesServiceUpdateUserDataFromJSON,
  HubbleCompaniesServiceUpdateUserDataFromJSONTyped,
  HubbleCompaniesServiceUpdateUserDataToJSON,
  HubbleCompaniesServiceUpdateUserDataToJSONTyped,
} from "./HubbleCompaniesServiceUpdateUserData";

/**
 *
 * @export
 * @interface HubbleCompaniesServiceUpdateUserHubble
 */
export interface HubbleCompaniesServiceUpdateUserHubble {
  /**
   *
   * @type {HubbleCompaniesServiceUpdateUserData}
   * @memberof HubbleCompaniesServiceUpdateUserHubble
   */
  newUserData: HubbleCompaniesServiceUpdateUserData;
  /**
   *
   * @type {HubbleCompaniesServiceUpdateUserData}
   * @memberof HubbleCompaniesServiceUpdateUserHubble
   */
  originalUserData: HubbleCompaniesServiceUpdateUserData;
}

/**
 * Check if a given object implements the HubbleCompaniesServiceUpdateUserHubble interface.
 */
export function instanceOfHubbleCompaniesServiceUpdateUserHubble(
  value: object,
): value is HubbleCompaniesServiceUpdateUserHubble {
  if (!("newUserData" in value) || value["newUserData"] === undefined)
    return false;
  if (!("originalUserData" in value) || value["originalUserData"] === undefined)
    return false;
  return true;
}

export function HubbleCompaniesServiceUpdateUserHubbleFromJSON(
  json: any,
): HubbleCompaniesServiceUpdateUserHubble {
  return HubbleCompaniesServiceUpdateUserHubbleFromJSONTyped(json, false);
}

export function HubbleCompaniesServiceUpdateUserHubbleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubbleCompaniesServiceUpdateUserHubble {
  if (json == null) {
    return json;
  }
  return {
    newUserData: HubbleCompaniesServiceUpdateUserDataFromJSON(
      json["newUserData"],
    ),
    originalUserData: HubbleCompaniesServiceUpdateUserDataFromJSON(
      json["originalUserData"],
    ),
  };
}

export function HubbleCompaniesServiceUpdateUserHubbleToJSON(
  json: any,
): HubbleCompaniesServiceUpdateUserHubble {
  return HubbleCompaniesServiceUpdateUserHubbleToJSONTyped(json, false);
}

export function HubbleCompaniesServiceUpdateUserHubbleToJSONTyped(
  value?: HubbleCompaniesServiceUpdateUserHubble | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    newUserData: HubbleCompaniesServiceUpdateUserDataToJSON(
      value["newUserData"],
    ),
    originalUserData: HubbleCompaniesServiceUpdateUserDataToJSON(
      value["originalUserData"],
    ),
  };
}
